export interface Intent {
  category_id?: number;
  category_name?: string;
  faq_name?: string;
  hotquestion_text?: string;
  icon_url?: string;
  intent_id: number;
  intent_name?: number;
  intent_type?: number;
  intent_source?: number;
  page_num?: number;
  query_callback?: any;
  seq?: number;
  shortcut_text?: string;
  last_trigger_dialogue_id?: string;
  session_id?: string;
  source?: number;
  is_repeated_session?: boolean;
}

export interface OtherFrequentlyAsked {
  text_key: string;
  text_value: string;
  query_callback: any;
  adhoc_category_name?: string[];
}

export interface IntentParams {
  page: number;
  session_id: string;
}

export enum IntentType {
  Prediction,
  HeadHotQuestionFixed,
  CategoryFixed,
  ShortcutFixed,
}

export enum IntentSource {
  DBConfiguration,
  KnowledgeBase,
  CategoryHotQuestion = 3,
  LiveAgentRecommender = 6,
  IntentClickOrder = 9,
}

export enum LiveAgentRecommenderScenario {
  TriggerRecommender = 1,
  GoDirectlyToAgent,
  GoOldLogic,
}

export enum AutoQueueFromType {
  NoAnyDialogue = 2, // 不展示任何卡片及 probing form，直接进线
}
